import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/DeleteSweep'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getButtonTestId } from './getButtonTestId'

/** @notExported  */
interface DeleteButtonProps {
  /** Action to be performed when the button is clicked. */
  clickAction: () => void
  /** Custom label for the button. */
  customLabel?: string
  /** Test id of the button. */
  testId?: string
}

/**
 * Delete button.
 *
 * @returns Delete button component.
 * @notExported
 * @category Buttons
 */
const DeleteButton: React.FC<DeleteButtonProps> = ({ clickAction, customLabel, testId }) => {
  const { t } = useTranslation()
  const label = customLabel ?? t('delete')
  const resolvedTestId = getButtonTestId({ fallback: 'button-delete', label, testId })

  return (
    <Button
      data-testid={resolvedTestId}
      startIcon={<DeleteIcon />}
      color="primary"
      aria-label={t('delete')}
      sx={{
        color: theme => theme.palette.text.primary,
        verticalAlign: 'center',
        '&:hover': {
          backgroundColor: theme => theme.palette.error.light,
          color: theme => theme.palette.error.dark,
        },
      }}
      onClick={() => clickAction()}
    >
      {label}
    </Button>
  )
}

export default DeleteButton
